import styled from "styled-components"
import { ControllerType } from "theme/theme"

const HR = styled.div`
  width: 100%;
  height: 1px;
  background: ${props => props.theme.colors.control[ControllerType.SECONDARY].hover};
`

export default HR